import { Gql, GqlLoyaltyTier } from '@fiverr-private/loyalty_utils';
import { BannerType, PayloadGigInfo } from './bannerPropsTypes';

const allTiers = Object.values(Gql.LoyaltyProgramTier);

export const useShouldShowBanner = ({
    gigInfo,
    loyaltyIndicationData,
    type,
}: {
    gigInfo: PayloadGigInfo;
    loyaltyIndicationData: Gql.EngagementBadgeInfo;
    type: BannerType;
}): boolean => {
    if (!loyaltyIndicationData) {
        return false;
    }

    const { orderEntitledForCredit, amountOver = 0, tier } = loyaltyIndicationData;
    const wasAlreadyUsed = orderEntitledForCredit === Gql.OrderEntitledForCredit.AlreadyUsed;
    const isValidForSilver = !wasAlreadyUsed && !!amountOver && gigInfo.gigPriceInUSDCents >= amountOver;

    if (
        wasAlreadyUsed ||
        (orderEntitledForCredit === Gql.OrderEntitledForCredit.FirstOrderOverAmount &&
            amountOver &&
            gigInfo.gigPriceInUSDCents < amountOver) ||
        !allTiers.includes(tier)
    ) {
        return false;
    }

    if (type === 'freelancer_page') {
        return (
            (tier === Gql.LoyaltyProgramTier.Silver && isValidForSilver) ||
            (tier === Gql.LoyaltyProgramTier.Gold && gigInfo.isProSeller) ||
            tier === Gql.LoyaltyProgramTier.Platinum ||
            tier === GqlLoyaltyTier.Diamond
        );
    }

    if (type === 'agency_page') {
        return (
            (tier === Gql.LoyaltyProgramTier.Silver && isValidForSilver) ||
            (tier === Gql.LoyaltyProgramTier.Gold && gigInfo.isProAgency) ||
            tier === Gql.LoyaltyProgramTier.Platinum ||
            tier === GqlLoyaltyTier.Diamond
        );
    }

    if (type === 'listings') {
        return tier !== Gql.LoyaltyProgramTier.Silver || isValidForSilver;
    }

    if (type === 'custom_offer_hourly') {
        return (
            (tier === Gql.LoyaltyProgramTier.Gold && gigInfo.isProSeller) ||
            tier === Gql.LoyaltyProgramTier.Platinum ||
            tier === GqlLoyaltyTier.Diamond
        );
    }

    return (
        orderEntitledForCredit === Gql.OrderEntitledForCredit.EveryOrder ||
        (orderEntitledForCredit === Gql.OrderEntitledForCredit.EachProSeller && !!gigInfo.isProSeller) ||
        (orderEntitledForCredit === Gql.OrderEntitledForCredit.FirstOrderOverAmount &&
            !!amountOver &&
            gigInfo.gigPriceInUSDCents > amountOver)
    );
};
